import React, { memo } from 'react';
import * as Styled from './styled';
import AllocationSelector from './allocation-selector/AllocationSelector';
import { SelectOption } from '@leasequery/lq.react-component-library';
import { ReportTypeSetting } from '../../../models/reportTypeSetting';
import { ClientCustomCalendarModel } from '../../../models';
import { Icon } from '../../../components';

interface ReportSettingPAndLProps {
  onChange: (updatedValue: ReportSettingPAndLState) => void;
  reportSettingState: ReportSettingPAndLState;
  reportTypeSetting: ReportTypeSetting;
  customCalendarSettings?: ClientCustomCalendarModel;
  isAllowPIT: boolean;
}

export interface ReportSettingPAndLState {
  selectedViewBy: SelectOption<string>;
  selectedSubViewBy?: SelectOption<string>;
  isValid: boolean;
}

function ReportSettingPAndL({
  onChange,
  reportSettingState,
  reportTypeSetting,
}: ReportSettingPAndLProps): JSX.Element {
  return (
    <>
      <Styled.DropdownBar>
        <div>
          <Icon name="gear" />
        </div>
        <AllocationSelector
          onChange={onChange}
          reportSettingState={reportSettingState}
          reportTypeSetting={reportTypeSetting}
        />
      </Styled.DropdownBar>
      <Styled.Line />
    </>
  );
}

export default memo(ReportSettingPAndL);
